import { ref } from 'vue'

const bookingModalOpen = ref(false)
const bookingInitialCheckIn = ref('')
const bookingInitialCheckOut = ref('')

export function useBookingModal() {
  const openBookingModal = (options = {}) => {
    bookingInitialCheckIn.value = options.checkIn || ''
    bookingInitialCheckOut.value = options.checkOut || ''
    bookingModalOpen.value = true
  }

  const closeBookingModal = () => {
    bookingModalOpen.value = false
    bookingInitialCheckIn.value = ''
    bookingInitialCheckOut.value = ''
  }

  return {
    bookingModalOpen,
    bookingInitialCheckIn,
    bookingInitialCheckOut,
    openBookingModal,
    closeBookingModal
  }
}
